import { lazy, Suspense } from 'react'
import { ThemeProvider } from '@mui/material/styles'
import CssBaseline from '@mui/material/CssBaseline'
import CircularProgress from '@mui/material/CircularProgress'
import Box from '@mui/material/Box'
import theme from '@/shared/theme/theme'
import { ErrorBoundary, Toast } from '@/shared/components/ui'

const HomeContent = lazy(() => import('@/features/home/components/HomeContent'))

const PageLoadingFallback = () => (
    <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', minHeight: '60vh' }}>
        <CircularProgress />
    </Box>
)

const App = () => (
    <ThemeProvider theme={theme}>
        <CssBaseline />
        <ErrorBoundary>
            <Suspense fallback={<PageLoadingFallback />}>
                <HomeContent />
            </Suspense>
        </ErrorBoundary>
        <Toast />
    </ThemeProvider>
)

export default App
